import { RELATIONSHIP_TWO_POLARITIES_SPREAD_DEFINITION } from './core.js';
import { createSpreadDefinition } from '../internal/builders.js';
export const AMORE_DINAMICA_DI_COPPIA_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'amore-dinamica-di-coppia',
    name: 'Amore e dinamica di coppia',
    slug: 'amore-dinamica-di-coppia',
    category: 'special',
    description: 'Sette carte per leggere attrazione, ferita, risorsa e traiettoria del legame.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'horseshoe',
    intent: ['relationship', 'healing'],
    semantic_tags: ['relational', 'conflict', 'forecast'],
    layout_id: 'horseshoe-7',
    position_specs: [
        { role_id: 'self', description: 'Come entri tu nel legame in questo momento?' },
        { role_id: 'other', description: 'Come entra l’altra persona nel legame?' },
        { role_id: 'bond', description: 'Quale trama tiene insieme il rapporto?' },
        { role_id: 'wound', description: 'Quale ferita o vulnerabilità si attiva fra voi?' },
        { role_id: 'desire', description: 'Che cosa desidera davvero questo legame al di là delle parole?' },
        { role_id: 'resource', description: 'Quale risorsa può sostenere la coppia?' },
        { role_id: 'outcome', description: 'Verso quale qualità relazionale state tendendo?' },
    ],
    keywords: ['coppia', 'amore', 'legame', 'dinamica'],
    recommended_for_questions: [
        'Che cosa sta nutrendo o svuotando questa relazione?',
        'Quale verità relazionale conviene guardare adesso?',
    ],
    contraindications: ['Non usarla per ottenere un verdetto assoluto sul futuro della coppia.'],
    focus_mode_ids: ['relationship-repair'],
    ritual_intensity: 2,
});
export const RELATIONSHIP_CHECK_IN_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'relationship-check-in',
    name: 'Relationship Check-In',
    slug: 'relationship-check-in',
    category: 'special',
    description: 'Check-in agile per misurare clima, attrito e gesto utile nel rapporto.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'beginner',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['relationship', 'clarity'],
    semantic_tags: ['relational', 'diagnostic'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'self', description: 'Dove sei tu nella relazione oggi?' },
        { role_id: 'other', description: 'Dove percepisci l’altra polarità?' },
        { role_id: 'bond', description: 'Qual è il clima reale fra voi?' },
        { role_id: 'challenge', description: 'Quale frizione chiede onestà?' },
        { role_id: 'advice', description: 'Quale gesto o parola può riequilibrare il campo?' },
    ],
    keywords: ['check-in', 'rapido', 'relazione', 'clima'],
    recommended_for_questions: [
        'Com’è davvero il campo tra noi oggi?',
        'Quale piccola correzione può aiutare il rapporto?',
    ],
    contraindications: ['Non ideale se serve una lettura storica lunga o una visione annuale del legame.'],
    focus_mode_ids: [],
    ritual_intensity: 1,
});
export const NUOVA_CONNEXIONE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'nuova-connessione',
    name: 'New Love / Nuova Connessione',
    slug: 'nuova-connessione',
    category: 'special',
    description: 'Cinque carte per leggere l’emergere di una nuova attrazione o relazione nascente.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['relationship', 'open'],
    semantic_tags: ['relational', 'forecast', 'diagnostic'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'self', description: 'Che cosa stai portando tu verso la nuova connessione?' },
        { role_id: 'other', description: 'Quale qualità mostra l’altro polo o la nuova presenza?' },
        { role_id: 'desire', description: 'Che cosa desidera davvero questa nascita relazionale?' },
        { role_id: 'challenge', description: 'Quale nodo conviene vedere presto?' },
        { role_id: 'outcome', description: 'Che traiettoria iniziale si sta disegnando?' },
    ],
    keywords: ['nuovo amore', 'connessione', 'attrazione', 'inizio'],
    recommended_for_questions: [
        'Che natura ha questa nuova connessione?',
        'Sto vedendo bene ciò che sta nascendo?',
    ],
    contraindications: ['Non usarla per forzare certezze assolute su una relazione appena nata.'],
    focus_mode_ids: ['relationship-polarity'],
    ritual_intensity: 2,
});
export const CONFINE_RELAZIONALE_SPREAD_DEFINITION = createSpreadDefinition({
    id: 'confine-relazionale',
    name: 'Confine Relazionale',
    slug: 'confine-relazionale',
    category: 'special',
    description: 'Lettura dedicata a limiti, soglie, reciprocità e spazio personale.',
    ritual_note: null,
    opening_invocation: null,
    closing_words: null,
    difficulty: 'intermediate',
    is_lilith: false,
    tree_of_life_mapping: false,
    family: 'line',
    intent: ['relationship', 'healing'],
    semantic_tags: ['relational', 'healing', 'diagnostic'],
    layout_id: 'line-5',
    position_specs: [
        { role_id: 'self', description: 'Quale limite personale va riconosciuto?' },
        { role_id: 'other', description: 'Quale richiesta o pressione arriva dall’altro polo?' },
        { role_id: 'hidden', description: 'Che cosa rende difficile nominare il confine?' },
        { role_id: 'resource', description: 'Quale risorsa sostiene un confine sano?' },
        { role_id: 'advice', description: 'Quale forma di parola o gesto va scelta?' },
    ],
    keywords: ['confine', 'reciprocità', 'spazio', 'limiti'],
    recommended_for_questions: [
        'Dove mi sto superando o ritirando troppo?',
        'Come posso proteggere il legame senza tradire me stesso?',
    ],
    contraindications: ['Non ideale se cerchi una previsione generica invece di lavorare sul presente.'],
    focus_mode_ids: [],
    ritual_intensity: 2,
});
export const RELATIONAL_SPREAD_DEFINITIONS = [
    RELATIONSHIP_TWO_POLARITIES_SPREAD_DEFINITION,
    AMORE_DINAMICA_DI_COPPIA_SPREAD_DEFINITION,
    RELATIONSHIP_CHECK_IN_SPREAD_DEFINITION,
    NUOVA_CONNEXIONE_SPREAD_DEFINITION,
    CONFINE_RELAZIONALE_SPREAD_DEFINITION,
];
//# sourceMappingURL=relational.js.map